import {Swiper, Navigation, Pagination} from 'swiper/dist/js/swiper.esm';

Swiper.use([Navigation, Pagination]);

export class RelatedProducts {
  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper('.js-wc-swiper-related', {
      slidesPerView: 4,
      spaceBetween: 20,
      pagination: {
        el: '.js-wc-swiper-related .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.js-wc-swiper-related .swiper-button-next',
        prevEl: '.js-wc-swiper-related .swiper-button-prev',
      },
      breakpoints: {
        800: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      },
    });
  }
}
